import { createContext, useEffect, useState, useCallback, useRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { SingleCustomerContextType, SinglecustomerInitialState } from "../../../types/types";
import { fetchCustomersFor360,
  getCustomersEvidence,
  getIdea,
  getSingleCustomerEvidence,
  getUnreadNotificationsCount,
  fetchConfigFor360,
  getCustomersEvidencesView, fetchGroupStructure } from "../../../Api";
import { useThrottle } from "../../../utils";

import { useDisclosure, useDebouncedValue } from "@mantine/hooks";
import { useSearchParams } from "react-router-dom";
import { DataTableSortStatus } from "mantine-datatable";
import { downloadEvidencesToCSV } from "../Export-Data/DownloadEvidences";
import { getTodayString } from "../Export-Data/DownloadEvidences";
import { useCurrentUser } from "../../../hooks/useCurrentUser";

const SingleCustomerContext = createContext<SingleCustomerContextType>(SinglecustomerInitialState);

const SingleCustomerContextProvider = ( { children } : { children: React.ReactNode } ) => {

  const auth0 = useAuth0();
  const currentUser = useCurrentUser();
  const userId = currentUser?.id;
  const [searchParams] = useSearchParams();
  const [threeSixtyConfig, setThreeSixtyConfig] =  useState<any>({})
  const [threeSixtyColumns, setThreeSixtyColumns] = useState<any[]>([])
  const [threeSixtyEvidenceColumns, setThreeSixtyEvidenceColumns] = useState<any[]>([])
  const [allComponents, setAllComponents] = useState<any[]>([])
  const [domains, setDomains] = useState<any[]>([])
  const [ideaStatuses, setIdeaStatuses] = useState<any[]>([])
  const [impactAggregationProperties, setImpactAggregationProperties] = useState<any>([]);
  const [ideaInfoTabsConfig, setIdeaInfoTabsConfig] = useState<any>({});
  const [customerIds, setCustomerIds] = useState<string[]>([])
  const [ideas, setIdeas] = useState<any[]>([]) 
  const [customer, setCustomer] = useState<any>({})
  const [customers, setCustomers] = useState<any[]>([]) 
  const [ cardOpened , setCardOpened ] = useState(false);
  const [customersItems, setCustomersItems] = useState<any[]>([])
  const [account, setAccount] = useState<any>(null);
  /* const [accountObj, setAccountObj] = useState<any>(null); */
  const [accountName, setAccountName] = useState<string>("");
  const [totalCustomersCount, setTotalCustomersCount] = useState<number>(0)
  const [chosenCustomer, setChosenCustomer] = useState<any>({})
  const [activeFilters, setActiveFilters] = useState<any[]>([])
  const [evidenceFilters, setEvidenceFilters] = useState<any[]>([])
  const [globalFilters, setGlobalFilters] = useState<any[]>([])
  const [ chosenEvidence , setChosenEvidence ] = useState<any>({});
  const [chosenIdea, setChosenIdea] = useState<any>({});
  const [textQuery, setTextQuery] = useState<string>('')
  const [unreadNotificationsMap, setUnreadNotificationsMap] = useState<any[]>(
    []
  );
  const [comments, setComments] = useState<any>({});
  const [unreadNotificationsLoading, setUnreadNotificationsLoading] =
    useState<boolean>(false);
  const [ideaId, setIdeaId] = useState<any>(null);
  const [activityOpened, setActivityOpened] = useState(false);
  const [isModalOpen, { open: openModal, close: closeModal }] = useDisclosure(false);
  const [isLoading, setIsLoading] = useState(false);
  const [ideasLoading, setIdeasLoading] = useState(false);
  const [evidencesLoading, setEvidencesLoading] = useState(false);
  const [idea, setIdea] = useState({})
  const [loadingIdea, setLoadingIdea] = useState(false)
  const [chosenCustomers, setChosenCustomers] = useState<any[]>([])
  const [evidences, setEvidences] = useState<any[]>([])
  const [evidenceId, setEvidenceId] = useState<string>('')
  const [loadingEvidence, setLoadingEvidence] = useState(false)
  const [isMultipleCustomers, setIsMultipleCustomers] = useState(false)
  const [isSegmentSelection, setIsSegmentSelection] = useState<boolean>(false)
  const [isSingleSelection, setIsSingleSelection] = useState<boolean>(false)
  const [groupBy, setGroupBy] = useState<string>('domainId')
  const [evidenceGroupBy, setEvidenceGroupBy] = useState<string>('flat')
  const [isReadyForSelect, setisReadyForSelect] = useState<boolean>(true)
  const [ideasFiltersConfig, setIdeasFiltersConfig] = useState<{
    evidence:any,
    idea:any
  }>(
    {
      evidence: {},
      idea: {},
    }
  );
  const [viewType, setViewType] = useState<'single' | 'multiple' | 'segment'>('segment')

  const [sortStatus, setSortStatus] = useState<DataTableSortStatus>(() => {
    const defaultSortColumn = threeSixtyConfig?.defaultSortColumnEvidencetable || 'priority';
    const defaultSortDirection = threeSixtyConfig?.defaultSortTypeEvidencetable || 'asc';

    return { columnAccessor: defaultSortColumn, direction: defaultSortDirection };
  });
  const [search, setSearch] = useState<string>('')
  const [debouncedSearch] = useDebouncedValue(search, 2000);
  const hasInitializedFromRoute = useRef(false);
  const isDeepLinkLoadRef = useRef(false);
  const customerIdParam = searchParams.get('customerId') || '';



  /* useEffect(() => {
    fetchCustomersEvidenceView(customerIds, viewType);
  }, [debouncedSearch]); */

  /* const loadAccount = () => {

    getSettingsForAccount(auth0)
      .then(connectedAccount => {
        setAccountObj(connectedAccount)
   
      })
      .catch((error) => console.log(error));
  }; */

  const loadIdea = async () => {
    if (!ideaId) {
      return false;
    }
    setLoadingIdea(true)
    const res = await getIdea(ideaId);
    setLoadingIdea(false)
    setIdea(res);
  
  };


  const openActivity = () => {
    setActivityOpened(true);
  };

  // On first load only: if URL has customerId query, clear saved views and set that id
  useEffect(() => {
    if (hasInitializedFromRoute.current) return;
    const queryId = customerIdParam;
    if (queryId) {
      isDeepLinkLoadRef.current = true;
      hasInitializedFromRoute.current = true;
      try {
        localStorage.removeItem('customer360Views');
      } catch (e) {
        console.log(e);
      }
      setActiveFilters([]);
      setViewType('single');
      setCustomerIds([queryId]);
      return;
    }
    hasInitializedFromRoute.current = true;
  }, [customerIdParam]);

  const getUnreadNotifications = async () => {
    if (!ideaId) {
      return false;
    }
    setUnreadNotificationsLoading(true);
    await getUnreadNotificationsCount(ideaId)
      .then(({ requests }) => {
        setUnreadNotificationsMap(requests);
      })
      .catch((e) => console.log(e))
      .finally(() => setUnreadNotificationsLoading(false));
  };

  const getUnreadNotificationsCountByRequest = (requestId: string) => {
    return (
      unreadNotificationsMap.find((request) => request._id == requestId)
        ?.unreadNotificationsCount || 0
    );
  };

  
  
  /* async function fetchCustomersEvidenceView(orgIds: string[], view: 'single' | 'multiple' | 'segment') {
    if (!orgIds) return;

    setEvidencesLoading(true);
    try {
      const sort: any = {};
      if (sortStatus?.columnAccessor) {
        sort[sortStatus.columnAccessor] = sortStatus.direction === "asc" ? 1 : -1;
      }

      if (threeSixtyConfig.name) {
        const res = await getCustomersEvidencesView(orgIds, evidenceFilters, sort, search, auth0)
      

        if (res && res.evidences) {
          setEvidences(res?.evidences || []);
        }
      

        if (res) {
          if(res?.evidences.length === 0 && res?.customers.length === 0){
            if (!isDeepLinkLoadRef.current) {
              handleModalOpen()
            }
          }

          setCustomersItems(res?.customers || {});
    
          if (res.customers.length == 1) {
            setIsSingleSelection(true)
            setIsSegmentSelection(false)
            setViewType('single')
          }
          else {
            setViewType(view)
            setIsSingleSelection(false)
            setIsSegmentSelection(true)
          }

          if(activeFilters.length > 0 && textQuery === '' && customerIds.length === 0) {
            setIsSingleSelection(false)
            setIsSegmentSelection(true)
            setViewType(view)
          }   

          setCustomer(res.customers[0])
        }
      }
    } catch (e) {
      console.error('Error fetching customer evidences view:', e);

    } finally {
      setEvidencesLoading(false);
  
      isDeepLinkLoadRef.current = false;
    }
  } */

  // Refetch function aligns to structure fetch in the new flow
  const refetchEvidences = useCallback(() => {
    if (customerIds.length === 0) return;
    const request: any = {
      orgIds: customerIds,
      groupBy: groupBy as any,
      filters: activeFilters,
      search: textQuery,
    };
    fetchGroupStructure(request).catch((e) => { console.log(e); });
  }, [customerIds, groupBy, activeFilters, textQuery]);

  // Explicit evidences fetch for Evidences tab
  /* const fetchEvidencesForSelection = useCallback(() => {
    if (customerIds.length > 0 && viewType) {
      fetchCustomersEvidenceView(customerIds, viewType);
    }
  }, [customerIds, viewType, evidenceFilters, sortStatus, search, threeSixtyConfig]); */


  async function fetchSingleCustomerEvidence(evidenceId: string) {
    if (!evidenceId) return;
    
    setLoadingEvidence(true);
    try {
      const res = await getSingleCustomerEvidence(evidenceId);
      if (res) {
        setChosenEvidence(res[0])
      }
    } catch (e) {
      console.error('Error fetching customer evidence:', e);
    } finally {
      setLoadingEvidence(false);
    }
  }

  const fetchCustomers = () => {
    setIsLoading(true);
    setisReadyForSelect(true)
    fetchCustomersFor360(textQuery, activeFilters, auth0)
      .then((res:any)=>{
        setCustomers(res.customers)
        setTotalCustomersCount(res.totalCount)
        if(res.isReadyForSelect === false){
          setisReadyForSelect(false)
        }

      }).catch((e:any)=>{
        console.log(e)
      }).finally(() => {
        setIsLoading(false);
      })
  }

  const fetchCustomersForOpenModal = () => {
    setIsLoading(true);
    fetchCustomersFor360('', [], auth0)
      .then((res:any)=>{
        setCustomersItems(res.customers)
        setTotalCustomersCount(res.totalCount)
      }).catch((e:any)=>{
        console.log(e)
      }).finally(() => {
        setIsLoading(false);
      })
  }

  const fetchConfig = () => {
    setIsLoading(true);
    fetchConfigFor360(auth0)
      .then((res: any)=>{
        setIdeasFiltersConfig(res.ideasFiltersConfig)
        if(res.threeSixtyConfiguration){
          setThreeSixtyConfig(res.threeSixtyConfiguration || {})
          setThreeSixtyColumns(res.threeSixtyConfiguration?.colomns || [])
          setThreeSixtyEvidenceColumns(res.threeSixtyConfiguration?.evidenceColomns || [])
          const globalFiltersFromConfig = res.threeSixtyConfiguration?.globalFilters || []
          setGlobalFilters(globalFiltersFromConfig)
          // Initialize evidenceFilters with global filters, preserving any existing user filters
          setEvidenceFilters((prev) => {
            // If prev is empty or only contains global filters, set to global filters
            // Otherwise, merge global filters with existing user filters
            if (prev.length === 0) {
              return globalFiltersFromConfig
            }
            // Merge: keep global filters and add/update user filters
            const userFilters = prev.filter((f: any) => !globalFiltersFromConfig.some((gf: any) => gf.parent === f.parent))
            return [...globalFiltersFromConfig, ...userFilters]
          })
          const sortedColumns = Array.isArray(res.threeSixtyConfiguration?.colomns)
            ? [...res.threeSixtyConfiguration.colomns].sort((a: any, b: any) => {
              const aIndex = typeof a?.index === 'number' ? a.index : Number.MAX_SAFE_INTEGER;
              const bIndex = typeof b?.index === 'number' ? b.index : Number.MAX_SAFE_INTEGER;
              return aIndex - bIndex;
            })
            : [];
          setThreeSixtyColumns(sortedColumns)
        }
        setAllComponents(res.allComponents)
        setDomains(res.domains)
        setIdeaStatuses(res.ideaStatuses)
        setImpactAggregationProperties(res.impactAggregationProperties)
        setIdeaInfoTabsConfig(res.ideaInfoTabsConfig)
        
        // Debug: Log impact properties
        console.log('[SingleCustomerContext] Impact properties loaded:', {
          count: res.impactAggregationProperties?.length || 0,
          properties: res.impactAggregationProperties?.map((prop: any) => ({
            fieldPath: prop.fieldPath,
            label: prop.label,
            isMainImpact: prop.impact?.isMainImpact,
            displayInEvidenceList: prop.displayInEvidenceList,
          })) || [],
          mainImpactProperty: res.impactAggregationProperties?.find((prop: any) => prop?.impact?.isMainImpact) || 'NOT FOUND',
        });
      }).catch((e:any)=>{
        console.log(e)
      }).finally(() => {
        setIsLoading(false);
      })
  }

  const throttledSearch = useThrottle(() => {
    fetchCustomers()
  }, 1000);


  // Trigger server-side group structure fetch (align with V2 'structure' call)
  /* useEffect(() => {
    const loadStructure = async () => {
      try {
        if (customerIds.length === 0) return;
        if (!threeSixtyConfig?.name) return;
        const request: any = {
          orgIds: customerIds,
          groupBy: groupBy as any,
          filters: activeFilters,
          search: textQuery,
        };
        const res = await fetchGroupStructure(request, auth0);
        if (res?.customers) {
          setCustomers(res.customers || []);
          setCustomersItems(res.customers || []);
        }
      } catch (e) {
        console.log(e);
      }
    };
    loadStructure();
  }, [customerIds, groupBy, activeFilters, textQuery, threeSixtyConfig?.name]); */


  const handleModalOpen = () => {
    setActiveFilters([])
    fetchCustomersForOpenModal()
    openModal()
  }

  const handleDownloadCSV = () => {
    const columns = [...threeSixtyEvidenceColumns]
      .filter(col => col.enabled)
      .sort(
        (a, b) => (a.index ?? 0) - (b.index ?? 0)
      );
    downloadEvidencesToCSV({evidences, columns, filename: customerIds.length > 1 ? `C360_Multiple_Companies_${getTodayString()}.csv` :`C360_${customers[0].name}_${getTodayString()}.csv`});
  }

  useEffect(() => {
    if (textQuery !== '') {

      throttledSearch();
    } else {
     
      fetchCustomers()
    }
  }, [activeFilters, textQuery]);


  useEffect(() => {
    
    if (customerIds.length > 0 && viewType) {
      const storageItem = {
        userId,
        viewType,
        filters :activeFilters,
        orgIs: customerIds,
        
      };
      
      // Get existing views from localStorage
      const existingViews = JSON.parse(localStorage.getItem('customer360Views') || '[]');
      
      // Find if there's an existing view for this userId
      const existingIndex = existingViews.findIndex((view: any) => view.userId === userId);
      
      if (existingIndex !== -1) {
        // Update existing view
        existingViews[existingIndex] = storageItem;
      } else {
        // Add new view
        existingViews.push(storageItem);
      }
      
      // Save updated array back to localStorage
      localStorage.setItem('customer360Views', JSON.stringify(existingViews));
    }
  }, [customerIds, activeFilters, userId]);

  // Update the initial load useEffect to set activeFilters from localStorage
  useEffect(() => {
    // Always load config (needed for evidences view fetch)
    fetchConfig()
    // If customerId query provided, skip loading from localStorage and modal logic
    if (customerIdParam) {
      return;
    }

    // Initial load - check localStorage
    const savedViews = JSON.parse(localStorage.getItem('customer360Views') || '[]');
    const userView = savedViews.find((view: any) => view.userId === userId);

 
    
    if (!userView) {
      // Scenario 1: No saved data, open modal
      handleModalOpen();
    } else if (userView.orgIs && userView.orgIs.length > 0 /* && userView?.accountId === accountObj?._id */) {
      // Scenario 2: Found saved data with orgIds, fetch evidence
      setCustomerIds(userView.orgIs);
      setViewType(userView.viewType);
      setActiveFilters(userView.filters || []);
      // Structure call handled by dedicated effect
    } else {
      // Scenario 3: Found saved data but no orgIds, open modal
      handleModalOpen();
    }
  }, [userId, customerIdParam]);

  // Add new useEffect to handle evidence fetching when customerIds change
  // Remove eager evidence fetch; groups and items are fetched on demand

  // Remove eager evidence view fetch; pagination is handled per-group on expansion
  /* useEffect(() => {
  
  }, [customerIds, evidenceFilters, sortStatus, threeSixtyConfig]); */

  // Add new useEffect to handle sortStatus initialization when threeSixtyConfig changes
  useEffect(() => {
    const defaultSortColumn = threeSixtyConfig?.defaultSortColumnEvidencetable || 'priority';
    const defaultSortDirection = threeSixtyConfig?.defaultSortTypeEvidencetable || 'asc';
    setSortStatus({ columnAccessor: defaultSortColumn, direction: defaultSortDirection });
  }, [threeSixtyConfig]);

  // Determine view type based on filters and customers list from modal
  

  return (
    <SingleCustomerContext.Provider
      value={{
        ideas,
        ideaStatuses,
        allComponents,
        customer,
        customers,
        cardOpened,
        setCardOpened,
        chosenEvidence,
        setChosenEvidence,
        threeSixtyConfig,
        activeFilters,
        setActiveFilters,
        evidenceFilters,
        setEvidenceFilters,
        textQuery,
        setTextQuery,
        customersItems,
        setCustomersItems,
        setCustomers,
        totalCustomersCount,
        setTotalCustomersCount,
        chosenCustomer,
        setChosenCustomer,
        isModalOpen,
        openModal,
        closeModal,
        account,
        accountName,
        setAccountName,
        setAccount,
        comments,
        setComments,
        getUnreadNotificationsCountByRequest,
        getUnreadNotifications,
        unreadNotificationsLoading,
        ideaId,
        setIdeaId,
        activityOpened,
        setActivityOpened,
        openActivity,
        chosenIdea,
        setChosenIdea,
        domains,
        isLoading,
        setIsLoading,
        ideasLoading,
        evidencesLoading,
        threeSixtyColumns,
        threeSixtyEvidenceColumns,
        customerIds,
        setCustomerIds,
        loadIdea,
        chosenCustomers,
        evidences,
        evidenceId,
        setEvidenceId,
        fetchSingleCustomerEvidence,
        loadingEvidence,
        setLoadingEvidence,
        isMultipleCustomers,
        setIsMultipleCustomers,
        isSegmentSelection,
        setIsSegmentSelection,
        handleModalOpen,
        handleDownloadCSV,
        isSingleSelection,
        setIsSingleSelection,
        ideasFiltersConfig,
        groupBy,
        setGroupBy,
        evidenceGroupBy,
        setEvidenceGroupBy,
        isReadyForSelect,
        viewType,
        setViewType,
        impactAggregationProperties,
        setThreeSixtyConfig,
        ideaInfoTabsConfig,
        sortStatus,
        setSortStatus,
        search,
        setSearch,
        refetchEvidences,
     
      }}
    >
      {children}
    </SingleCustomerContext.Provider>
  );
};

export { SingleCustomerContext, SingleCustomerContextProvider };
export default SingleCustomerContext;